document.addEventListener("DOMContentLoaded", () => {
  const productGrid = document.querySelector('#facets-results');
  const spinner = document.getElementById('infinite-scroll-spinner');
  const paginationWrapper = document.querySelector('.pagination');
  let nextPageLink = document.querySelector('.pagination__next');

  if (!productGrid || !nextPageLink) return;

  const observerTarget = document.createElement('div');
  observerTarget.style.height = '1px';
  document.body.appendChild(observerTarget);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && nextPageLink) {
        observer.unobserve(observerTarget);

        if (spinner) spinner.style.display = 'block';
        if (paginationWrapper) paginationWrapper.style.display = 'none';

        fetch(nextPageLink.href)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newProductsHTML = doc.querySelector('#facets-results')?.innerHTML;
            const newNextLink = doc.querySelector('.pagination__next');

            if (newProductsHTML) {
              productGrid.insertAdjacentHTML('beforeend', newProductsHTML);
              
              const newImages = productGrid.querySelectorAll('img.tile-media:not(.is-complete)');
              
              newImages.forEach(img => {
                if (img.complete) {
                  img.classList.add('is-complete');
                } else {
                  img.addEventListener('load', () => {
                    img.classList.add('is-complete');
                  });
                }
              });
            }

            if (spinner) spinner.style.display = 'none';

            if (newNextLink) {
              nextPageLink.href = newNextLink.href;
              if (paginationWrapper) paginationWrapper.style.display = 'none';
              observer.observe(observerTarget);
            } else {
              nextPageLink = null;
              observerTarget.remove();
              if (paginationWrapper) paginationWrapper.style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Infinite scroll error:', error);
            if (spinner) spinner.style.display = 'none';
            if (paginationWrapper) paginationWrapper.style.display = 'block';
          });
      }
    });
  }, {
    rootMargin: '600px',
  });

  observer.observe(observerTarget);
});
